import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import HeaderPersonal from "../../components/funcionarios/HeaderPersonal";
import AdminModulosDisplay from "../../components/jefatura/AdminModulosDisplay";
import MotivosActuales from "../../components/jefatura/MotivosActuales";
import { getMesones } from "../../services/apis_funcionarios";
import { getMotivosEstudiante } from "../../services/apis_estudiante";
import { actualizarMeson } from "../../services/apis_jefatura";

const styles = {
  container: {
    fontFamily: "var(--font-funcionarios)",
  },
  rowSuperior: {
    minHeight: "15vh",
  },
};

function AdministradorModulos() {

  const [mesones, setMesones] = useState([]);
  const [motivos, setMotivos] = useState([]);

  async function fetchMesones() {
    try {
      const data = await getMesones();
      setMesones(data);
    } catch (err) {
      console.error("Error cargando mesones:", err);
    }
  }

  async function fetchMotivos() {
    try {
    const data = await getMotivosEstudiante();
    setMotivos(data);
    } catch (err) {
      console.error("Error cargando motivos:", err);
    }
  }

  useEffect(() => {
    fetchMesones();
    fetchMotivos();
  }, []);

  return (
    <Container fluid className="p-0 m-0 w-100">
      <Row className="g-3">
          <Col lg={6} className="h-md-100">
            <HeaderPersonal />
          </Col>

          <Col lg={6} className="h-md-100">
            <MotivosActuales
              motivos={motivos}
              onModulosChanged={fetchMesones}
              onMotivosChanged={fetchMotivos}
            ></MotivosActuales>
          </Col>
          <Col xs={12}>
            <AdminModulosDisplay
              modulos={mesones}
              onModulosChanged={fetchMesones}
              onMotivosChanged={fetchMotivos}
            />
          </Col>
        </Row>
    </Container>
  );
}

export default AdministradorModulos;